import { environment } from '../environments/environment';
import { logger } from 'app/core/util/logger';
import { ConfigMW } from 'app/core/interfaces/config.interface';

export const appSettings = {
  ADMIN_PAGE_SIZE: 50,
  PAGE_SIZE: 25,
  DEFAULT_LANGUAGE: 'default',
  DEFAULT_ROUTE: '/dashboard',
  PUBLIC_PAGE_ROUTE: '/login',
  SELECT_CUSTOMER_ROUTE: 'customer/select',

  DATE_FORMAT_ANGULAR: 'dd/MM/yyyy',
  DATE_FORMAT_DATEPICKER: 'dd/mm/yyyy',
  WEEK_FORMAT_DATEPICKER: 'week ww, yyyy',
  DATE_FORMAT_MOMENT: 'DD/MM/YYYY',
  DATE_FORMAT_MOMENT_REST: 'YYYY-MM-DD',

  FLOW_STATUS_WAITING_FOR_HANDSHAKE: '02',
  FLOW_STATUS_HANDSHAKE_WITH_DIFFERENCE: '03',
  FLOW_STATUS_WAITING_FOR_SUPPLIER_REGISTRATION: '06',
  FLOW_STATUS_WAITING_FOR_DISPUTE_MANAGEMENT: '07',

  MATERIAL_TYPE_COMBINATION: 'combination' as 'combination',
  MATERIAL_TYPE_PALLET: 'pallet' as 'pallet',
  MATERIAL_TYPE_PACKING: 'packing' as 'packing',

  USE_MOCK_REST_DATA: !environment.production && false, // TODO remove in production !!!

   ARTIFICIAL_DELAY_MS: 1000,

  LANGUAGE: 'en',

  LABEL_WIDTH: '150px',
  LABEL_WIDTH_WIDE: '200px',
};

logger.log(`Work offline: ${appSettings.USE_MOCK_REST_DATA}`);

export function getEnvironment(): string {
  const config = window['config'] as ConfigMW;
  const env = (config.environment || '').toLowerCase();

  const url = document.location.href;
  if (/http:\/\/localhost/.test(url)) {
    return 'localhost-' + env;
  }

  if (['dev', 'qas', 'sandbox'].indexOf(env) >= 0) {
    return env;
  }

  return '';
}
